import { Container as ContainerBase } from 'ui/components/primitives';
import { styled, theme, utils } from 'ui/theme';

export const Container = styled(ContainerBase)`
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${utils.media.max('m')`
    position: fixed;
    top: 0;
    background-color: ${theme.colors.build.lightLight};
    z-index: 1;
  `}

  &[data-has-button='true'] {
    ${utils.media.max('m')`
      justify-content: flex-start;
    `}
  }
`;

export const ButtonContainer = styled.div`
  button {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const HeaderPageContainer = styled.div`
  height: 64px;

  div[data-brand='eud'] {
    height: ${theme.sizes[8]};
  }
`;
